import React from 'react';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure } from 'react-instantsearch-hooks-web';
import { useInfiniteHits } from 'react-instantsearch-hooks-web';
import slugify from 'slugify';

const searchClient = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_ONLY_KEY);
const indexName = 'shopify_products';

const ColorHits = (props) => {
  const { hits } = useInfiniteHits(props);
  if (!hits.length) {
    return null;
  }
  return (
    <div className="product-colors-widget" data-type="color">
      {hits.map((hit) => (
        <a
          href={`/products/${hit.handle}?variant=${hit.objectID}`}
          data-color={slugify(hit.option1, { lower: true, sortBy: ['name:asc'] })}
          target="_blank"
        >
          <span className="screen-reader-text">{hit.option1}</span>
        </a>
      ))}
    </div>
  );
};

const ProductColors = (props) => {
  return (
    <InstantSearch searchClient={searchClient} indexName={indexName}>
      <Configure filters={`_tags: "${props.indexId}"`} distinct={false}></Configure>
      <ColorHits></ColorHits>
    </InstantSearch>
  );
};

export default ProductColors;
